import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1280.000000 1280.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
<path d="M6165 9949 c-152 -36 -230 -75 -348 -172 -77 -64 -105 -105 -314
-467 -50 -85 -114 -195 -143 -245 -29 -49 -64 -110 -78 -135 -14 -25 -50 -88
-80 -140 -30 -52 -63 -108 -72 -125 -9 -16 -77 -133 -150 -260 -73 -126 -146
-255 -163 -285 -17 -30 -45 -77 -62 -105 -82 -131 -117 -255 -117 -411 0 -85
5 -127 23 -185 57 -190 163 -334 319 -434 126 -80 221 -107 390 -109 147 -1
198 11 350 82 110 52 246 190 322 327 31 55 95 168 143 250 48 83 95 164 105
180 9 17 31 54 49 83 17 29 31 54 31 56 0 2 18 34 41 71 22 37 49 83 60 101
10 19 29 51 41 72 11 20 26 46 32 57 7 11 27 47 46 80 19 33 42 72 50 86 8 15
62 108 120 208 58 100 114 198 126 219 12 20 31 53 42 72 76 125 114 256 115
395 1 363 -227 644 -596 733 -56 14 -225 14 -282 1z"/>
<path d="M7280 8084 c-83 -10 -258 -73 -268 -96 -2 -5 -8 -8 -13 -8 -25 0
-147 -111 -206 -186 -93 -120 -165 -354 -148 -483 16 -125 60 -267 104 -336
26 -43 223 -383 274 -475 17 -30 38 -67 46 -82 49 -81 111 -189 133 -228 14
-25 40 -70 58 -100 18 -30 41 -68 50 -85 9 -16 28 -48 41 -71 13 -23 53 -92
88 -155 35 -63 78 -136 96 -164 18 -27 34 -55 36 -61 17 -46 155 -259 199
-307 156 -170 365 -257 582 -244 243 15 446 130 582 329 72 107 125 280 126
410 0 103 -40 253 -95 353 -12 22 -37 67 -55 100 -18 33 -40 71 -50 85 -9 14
-28 45 -42 70 -14 25 -67 117 -118 205 -51 88 -106 184 -121 213 -16 30 -38
66 -49 82 -11 15 -20 31 -20 35 0 4 -8 19 -18 33 -11 15 -33 52 -49 82 -25 46
-94 166 -193 335 -10 17 -43 75 -75 130 -199 345 -232 392 -337 473 -63 48
-146 93 -208 111 -25 7 -56 17 -69 22 -26 11 -225 20 -281 13z"/>
<path d="M4163 6469 c-99 -17 -226 -74 -318 -143 -144 -107 -247 -281 -281
-471 -19 -107 -18 -143 7 -260 47 -226 185 -406 390 -513 41 -22 85 -42 99
-45 168 -38 126 -37 1167 -37 985 0 1044 2 1148 33 106 31 245 117 321 199 49
51 120 167 156 254 33 79 33 79 33 249 0 167 -1 171 -33 254 -73 191 -204 334
-383 419 -149 71 -71 67 -1219 68 -569 1 -1058 -2 -1087 -7z"/>
<path d="M5948 4573 c-69 -43 -37 -153 45 -153 34 0 67 26 80 62 11 32 -14 79
-49 94 -41 17 -43 17 -76 -3z"/>
<path d="M6619 4575 c-29 -16 -52 -66 -42 -93 13 -36 46 -62 80 -62 86 0 115
118 38 154 -40 19 -43 19 -76 1z"/>
<path d="M4540 4538 c-1 -2 -1 -151 -1 -333 l-1 -330 76 -3 76 -3 0 336 0 335
-75 0 c-41 0 -75 -1 -75 -2z"/>
<path d="M4826 4531 c-3 -5 -5 -154 -3 -332 l2 -324 78 -3 77 -3 0 65 c0 55 4
69 25 93 25 28 25 28 41 8 8 -11 33 -53 55 -92 l40 -73 90 0 c49 0 89 2 89 4
0 3 -38 67 -85 144 -47 76 -85 144 -85 150 0 6 36 49 80 95 44 47 80 87 80 91
0 3 -37 6 -82 6 l-83 0 -73 -80 c-40 -44 -78 -80 -83 -80 -5 0 -9 71 -9 170
l0 170 -74 0 c-41 0 -77 -4 -80 -9z"/>
<path d="M3902 4191 c-73 -169 -132 -311 -132 -315 0 -4 37 -6 81 -4 l81 3 20
53 19 52 143 0 143 0 19 -52 19 -53 83 -3 c54 -2 82 1 82 8 0 6 -46 120 -101
253 -56 133 -113 270 -127 305 l-25 62 -87 0 -86 0 -132 -309z m262 27 c21
-54 35 -102 31 -108 -8 -13 -152 -13 -160 0 -5 8 54 184 72 213 9 14 18 -3 57
-105z"/>
<path d="M6860 4185 l0 -317 188 4 c167 3 192 6 235 25 77 36 123 78 156 145
27 52 31 72 31 138 0 43 -7 96 -16 123 -21 63 -83 130 -152 164 -56 27 -62 28
-249 31 l-193 4 0 -317z m357 168 c19 -9 47 -34 61 -56 23 -34 27 -52 27 -111
0 -79 -19 -123 -68 -160 -23 -17 -46 -22 -118 -24 l-89 -4 0 186 0 186 76 0
c50 0 88 -6 111 -17z"/>
<path d="M8118 4403 c-3 -65 -4 -68 -27 -65 -27 4 -41 -12 -41 -50 0 -44 10
-58 41 -58 l29 0 0 -112 c0 -131 10 -175 47 -212 39 -40 91 -52 165 -38 34 6
66 16 71 21 6 6 5 28 -3 60 -12 51 -12 51 -45 45 -18 -3 -43 -3 -54 1 -20 6
-21 14 -21 120 l0 114 63 3 62 3 0 50 0 50 -60 1 -60 1 -3 67 -3 66 -79 0 -79
0 -3 -67z"/>
<path d="M5540 4359 c-82 -9 -170 -37 -170 -54 0 -11 12 -44 36 -93 0 -1 20 5
44 13 64 22 155 20 180 -5 11 -11 20 -29 20 -40 0 -18 -7 -20 -87 -20 -109 0
-153 -12 -192 -51 -77 -76 -35 -210 74 -241 51 -14 134 2 173 33 l27 21 3 -26
c3 -25 5 -26 78 -26 l75 0 -3 193 c-3 183 -4 194 -26 225 -42 58 -124 83 -232
71z m110 -309 c0 -45 -41 -80 -95 -80 -52 0 -75 19 -75 61 0 37 23 48 108 48
l62 1 0 -30z"/>
<path d="M5914 4347 c-2 -7 -3 -116 -2 -242 l3 -230 78 -3 77 -3 0 246 0 245
-75 0 c-52 0 -77 -4 -81 -13z"/>
<path d="M6200 4115 l0 -245 75 0 75 0 0 126 c0 94 4 134 16 159 17 37 66 65
113 65 l31 0 0 71 0 72 -37 -6 c-20 -4 -53 -20 -74 -37 -21 -16 -40 -30 -43
-30 -3 0 -6 16 -6 35 l0 35 -75 0 -75 0 0 -245z"/>
<path d="M6580 4115 l0 -245 80 0 80 0 0 245 0 245 -80 0 -80 0 0 -245z"/>
<path d="M7675 4356 c-5 -3 -36 -12 -68 -22 -63 -18 -62 -16 -31 -91 15 -38
12 -37 57 -18 20 8 65 15 100 15 70 0 97 -17 97 -58 0 -21 -4 -22 -84 -22
-117 0 -143 -7 -188 -52 -36 -36 -38 -42 -38 -98 0 -56 2 -62 39 -99 31 -31
49 -40 89 -46 57 -8 118 6 156 36 14 11 27 16 27 10 1 -6 2 -17 3 -23 1 -9 26
-14 79 -16 l79 -3 -4 189 c-3 180 -4 190 -27 223 -39 58 -73 72 -181 75 -52 2
-99 2 -105 0z m155 -310 c0 -47 -37 -76 -96 -76 -33 0 -46 5 -58 22 -21 30
-20 44 4 68 16 16 33 20 85 20 l65 0 0 -34z"/>
<path d="M8625 4355 c-5 -2 -36 -11 -67 -20 -36 -10 -58 -21 -58 -30 0 -11 12
-44 36 -93 0 -1 20 5 44 13 64 22 155 20 180 -5 11 -11 20 -29 20 -40 0 -19
-7 -20 -97 -20 -82 -1 -106 -4 -143 -23 -76 -39 -101 -122 -59 -197 11 -20 33
-44 48 -53 62 -36 161 -30 223 15 l28 19 0 -25 c0 -26 1 -26 76 -26 l75 0 -3
194 c-3 222 -7 232 -88 274 -36 18 -60 22 -125 21 -44 0 -84 -2 -90 -4z m155
-303 c0 -45 -32 -74 -88 -80 -54 -5 -82 13 -82 51 0 45 19 55 108 56 62 1 62
1 62 -27z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
